import { RootState } from '../index';
import { createSelector } from '@reduxjs/toolkit';
import { ChatMessageData } from './types';

export const messagesByRoom = (roomId: string) => {
  return (state: RootState): ChatMessageData[] => {
    return state?.chatMessages.entities[roomId]?.messages ?? [];
  };
};

export const selectAllMessages = (state: RootState): ChatMessageData[] =>
  Object.values(state.chatMessages.entities).reduce((acc, item) => [...acc, ...item.messages], [] as ChatMessageData[]);

export const selectSortedMessagesByRoom = (roomId: string) =>
  createSelector(messagesByRoom(roomId), (items) => {
    const sortedArr = [...items];
    return sortedArr.sort((a, b) => a.updated_at - b.updated_at);
  });

export const selectTotalUnReadMessages = (userID: string) =>
  createSelector(selectAllMessages, (items) => {
    return items.filter((message) => message.status !== 'viewed' && message.receiver_id === userID);
  });

export const selectorIsLoading = (state: RootState) => state.chatMessages.loading;

export const selectIsInfiniteSelectorByRoomId =
  (roomId: string) =>
  (state: RootState): boolean => {
    return state.chatMessages.entities[roomId]?.isInfiniteDisabled ?? true;
  };
